module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_c('strong', [_vm._v("Acknowledgments")])])]), _c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A great many institutions and people contributed to the research reported in this volume. I gratefully appreciate the generous financial support of the Smith Richardson Foundation in the form of a grant to the National Bureau of Economic Research. Martin Feldstein, James Poterba, and Andrei Shleifer provided invaluable guidance and intellectual encouragement throughout the process. Carl Beck and Brett Maranjian organized our group’s meetings flawlessly. David Pervin, our editor at the University of Chicago Press, helped me and the contributors navigate the publication process and refine the chapters. Two anonymous referees provided numerous helpful suggestions for revision. Finally, Helena Fitz-Patrick made the production of the book—an editor’s least favorite job—wonderfully smooth and efficient.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1207e712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226432212_07_Ack.vue
// module id = 75
// module chunks = 0